// extracted by mini-css-extract-plugin
export default {"BackgroundDesktop":"BlueBg_BackgroundDesktop__+D1FD","BackgroundMobile":"BlueBg_BackgroundMobile__OFnUA"};